import Wrench from './wrench';
import {useGetTrackingErrorsQuery} from '../features/api/apiSlice';

const ErrorPage = ({title, body}: {title?: string; body?: string}) => {
  const {data: trackingErrors} = useGetTrackingErrorsQuery();
  const defaultTitle = trackingErrors?.defaultTitle;
  const defaultError = trackingErrors?.defaultError;

  return (
    <div className={styles.container} data-testid="error-container">
      <div className={styles.contentWrapper}>
        <Wrench height="75" width="75" data-testid="error-wrench" />
        <div className={styles.errorPageTitle} data-testid="error-title">
          {title || defaultTitle}
        </div>
        <div className={styles.errorPageBody} data-testid="error-body">
          {body || defaultError}
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;

const styles = {
  container: 'p-8 flex justify-center',
  contentWrapper: 'flex flex-col justify-center items-center',
  errorPageTitle: 'mt-8 text-primary font-light text-3xl mb-2 text-wrap',
  errorPageBody: 'text-darker-gray text-lg tracking-wider mx-8',
};
